<script lang="ts">
    import { DEFAULT_LAYOUT } from '$lib/components/constants';

    import { cn } from '$lib/utils/cn';

    import { getThemedOrCustomColor } from '../_utils/getThemedOrCustomColor';
    import Box from '../_wrappers/Box.svelte';
    import Block from '../Block.svelte';

    import type { Box as BoxType, FlexAlign } from '$lib/types/Components/SharedTypes';
    import type { Component } from '$lib/types/Components/SharedTypes';
    import type { Field } from '$lib/types/Field';
    import type { Language } from '$lib/types/Language';
    import type { ResultMapping } from '$lib/types/ResultMapping';
    import type { TransitionEffect, Theme } from '$lib/types/Theme';
    import type { TrackingProperty } from '$lib/types/TrackingProperty';

    export let box: BoxType;
    export let verticalAlign: FlexAlign;
    export let framed = false;
    export let childComponents: Component[] = [];
    export let transitionDelay = 0;
    export let transitionEffect: TransitionEffect = 'default';
    export let resultMapping: ResultMapping;
    export let theme: Theme;
    export let nextPage = '';
    export let currentPage = '';
    export let campaignId = '';
    export let campaignVersionId = '';
    export let companyId = '';
    export let cookiesEnabled = false;
    export let fields: Field[] = [];
    export let firstResultPage = '';
    export let trackingProperties: TrackingProperty[] = [];
    export let language: Language = 'en';
    export let layout = DEFAULT_LAYOUT;

    const isSingleColumn = layout.columnCount === 1;

    const columnBox: BoxType = {
        top: 'none',
        right: 'none',
        bottom: 'none',
        left: 'none',
        backgroundColor: framed
            ? getThemedOrCustomColor(box.backgroundColor || '', 'backgroundColor', theme)
            : 'transparent',
        bgImage: framed ? box.bgImage : undefined,
    };
</script>

<Box {...columnBox} {transitionDelay} {transitionEffect} rounded fullHeight>
    <div
        class={cn('fun-flex fun-h-full fun-flex-col fun-p-2 sm:fun-p-0', {
            'sm:fun-p-6': !isSingleColumn,
            'fun-p-4 sm:fun-p-10': framed && !isSingleColumn,
            'fun-p-4 sm:fun-p-10 lg:fun-px-0': framed && isSingleColumn,
            'fun-justify-start': verticalAlign === 'start',
            'fun-justify-center': verticalAlign === 'center',
            'fun-justify-end': verticalAlign === 'end',
            'fun-min-h-[375px]': framed && box.bgImage?.visible,
        })}
    >
        {#each childComponents as component, index}
            <Block
                id={component._id}
                {language}
                {campaignId}
                {campaignVersionId}
                {companyId}
                {cookiesEnabled}
                componentType={component.componentType}
                childComponents={component.components}
                content={component.content}
                {theme}
                {nextPage}
                {currentPage}
                {resultMapping}
                {fields}
                {firstResultPage}
                {trackingProperties}
                {index}
                layout={{ ...layout, isInColumn: true, isInFramedColumn: framed }}
            />
        {/each}
    </div>
</Box>
